import { render, staticRenderFns } from "./tabSopState.vue?vue&type=template&id=48bd8068&"
import script from "./tabSopState.vue?vue&type=script&lang=js&"
export * from "./tabSopState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48bd8068')) {
      api.createRecord('48bd8068', component.options)
    } else {
      api.reload('48bd8068', component.options)
    }
    module.hot.accept("./tabSopState.vue?vue&type=template&id=48bd8068&", function () {
      api.rerender('48bd8068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabSopState.vue"
export default component.exports